<template>
  <div class="dropdown notifications apps">
    <button
      class="btn btn-secondary border-0 p-0 position-relative"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <span class="material-symbols-outlined">apps</span>
    </button>

    <div class="dropdown-menu dropdown-lg p-0 border-0 py-4 px-3 max-h-312">
      <div
        class="notification-menu d-flex flex-wrap justify-content-between gap-4"
      >

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebApps",
};
</script>
